module.exports = __webpack_public_path__ + "static/logo-087533e8ebf341432288c8fef8598bdb.png";